import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RequireGameAuth from '../../shared/components/RequireGameAuth';
import Layout from '../../shared/components/Layout';
import Sidebar from '../../shared/components/Sidebar';
import LevelsPage from './pages/LevelsPage';
import { auth } from './firebase';
import navItems from './nav';
import './theme.css';

const NeonApp = () => (
  <div className="game-neon">
    <RequireGameAuth auth={auth} title="Neon Breaker Admin">
      {(user) => (
        <Layout
          title="Neon Breaker Admin"
          renderSidebar={({ isOpen, closeSidebar }) => (
            <Sidebar
              auth={auth}
              brandLabel="Neon Breaker"
              navItems={navItems}
              isOpen={isOpen}
              closeSidebar={closeSidebar}
              userEmail={user?.email}
            />
          )}
        >
          <Routes>
            <Route path="/" element={<LevelsPage />} />
          </Routes>
        </Layout>
      )}
    </RequireGameAuth>
  </div>
);

export default NeonApp;
